<template>
  <div :class="rootContainerClass">
    <section>
      <div v-if="currentUser.role_id == 1" class="d-flex align-items-center justify-content-between flex-wrap mb-3">
        <h3 class="mb-0">Client Docs</h3>
      </div>

      <div v-if="currentUser.role_id == 1" class="card p-2 mb-3">
        <div class="row align-items-end">
          <div class="col-12 col-md-6 col-lg-4 p-1 client-docs-filter-col position-relative">
            <div class="input-group input-group-sm w-100">
              <div class="input-group-prepend">
                <span class="input-group-text">{{ $t("lang.label.client") }}</span>
              </div>
              <treeselect
                :disabled="loadingClients"
                v-model="filterSearch.client_id"
                :options="clientsForTreeselect"
                :normalizer="normalizeOptions"
                :searchable="true"
                :multiple="false"
                :clearable="true"
                :max-height="300"
                v-bind:placeholder="$t('lang.label.search')"
                @search-change="onClientSearchChange"
                class="form-control inline-table flex-grow-1"
              />
              <small
                v-if="loadingClients"
                style="width:15px;height:15px; position: absolute; bottom: 33px; right: 0px;"
                class="spinner-border loading-spinner"
              ></small>
            </div>
          </div>
          <div class="col-12 col-md-6 col-lg-4 p-1 d-flex align-items-center mt-2 mt-md-0">
            <button class="btn btn-success btn-sm" :disabled="loading" @click="loadDocuments(true)">
              <i class="icon-search mr-1"></i>
              {{ $t("lang.button.filter") }}
            </button>
          </div>
        </div>
      </div>

      <LoadingSpinner v-if="loading" />

      <div v-else>
        <div class="col-md-12 w-100 my-2 card px-2">
          <div class="row my-2">
            <div class="col-md-12 d-flex align-items-center justify-content-between flex-wrap">
              <div>
                <span class="mr-1">{{ $t("lang.label.results") }}:</span>
                <small v-if="loadingTotal" class="ml-1 text-primary mr-4">{{ $t("lang.search.calculating") }}...</small>
                <strong v-else>{{ total }}</strong>
              </div>
              <Pagination
                :total="total"
                :totalpage="totalPageDocuments"
                :model="pagination"
                :limit="false"
                :color="'primary'"
                key="client-docs-pagination"
                @changePage="changePage"
              />
            </div>
          </div>
        </div>

        <div class="card mt-3 p-4">
          <div v-if="documents.length === 0" class="text-muted text-center py-4">
            No documents found
          </div>
          <div v-else class="table-responsive">
          <table class="table table-hover thead-dark mb-0">
            <thead>
              <tr>
                <th v-if="currentUser.role_id == 1">{{ $t("lang.label.client") }}</th>
                <th>Type</th>
                <th>Doc reference</th>
                <th class="text-right">{{ $t("lang.label.download") }}</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="row in documents" :key="`${row.doc_type}-${row.entity_id}`">
                <td v-if="currentUser.role_id == 1">{{ row.client_name }}</td>
                <td>
                  <span
                    class="badge"
                    :class="row.doc_type === 'Contract' ? 'badge-primary' : 'badge-info'"
                  >
                    {{ row.doc_type }}
                  </span>
                </td>
                <td>{{ row.doc_reference }}</td>
                <td class="text-right">
                  <button
                    class="btn btn-sm btn-success"
                    :disabled="downloadingKey === downloadKey(row)"
                    @click="downloadDocument(row)"
                  >
                    <span
                      v-if="downloadingKey === downloadKey(row)"
                      class="spinner-border spinner-border-sm mr-1"
                    ></span>
                    <i v-else class="icon-download mr-1"></i>
                    {{ $t("lang.label.download") }}
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
import LoadingSpinner from "@/components/LoadingSpinner.vue";
import Pagination from "@/components/Common/Pagination.vue";
import { clientsService, billingsService } from "@/_services";
import Treeselect from "@riophae/vue-treeselect";
import "@riophae/vue-treeselect/dist/vue-treeselect.css";

const CLIENT_STATUS_IDS_ALLOWED = [4, 7, 8, 5, 6];
const PINNED_CLIENT_ID = 2389;

export default {
  components: {
    LoadingSpinner,
    Treeselect,
    Pagination,
  },
  data() {
    return {
      loading: true,
      loadingTotal: false,
      loadingClients: false,
      clientSearchQuery: "",
      clientSearchTimer: null,
      clients: [],
      documents: [],
      total: 0,
      downloadingKey: null,
      pagination: {
        imported: false,
        refreshlist: false,
        selectfirst: false,
        cantPerPage: 25,
        currentPage: 1,
      },
      filterSearch: {
        client_id: null,
      },
    };
  },
  computed: {
    ...mapState({
      currentUser: (state) => state.authentication.user,
    }),
    clientsForTreeselect() {
      var q = (this.clientSearchQuery || "").trim().toLowerCase();

      if (!q) {
        var limit = 50;
        var first = this.clients.slice(0, limit);
        var pinned = this.clients.find(function (c) {
          return c.id == PINNED_CLIENT_ID;
        });
        if (!pinned || first.some(function (c) { return c.id == pinned.id; })) {
          return first;
        }
        return [pinned].concat(
          first.filter(function (c) { return c.id != pinned.id; }).slice(0, limit - 1)
        );
      }

      if (q.length < 2) return [];

      var out = [];
      for (var i = 0; i < this.clients.length; i++) {
        var c = this.clients[i];
        if (c._search && c._search.indexOf(q) !== -1) {
          out.push(c);
          if (out.length >= 200) break;
        }
      }
      return out;
    },
    totalPageDocuments() {
      return this.documents.length;
    },
    rootContainerClass() {
      if (this.currentUser.role_id == 4) {
        return "contenedor client-docs-client";
      }
      return "main px-5";
    },
  },
  created() {
    if (this.currentUser.role_id == 1) {
      this.getClients();
    }
    this.loadDocuments(true);
  },
  mounted() {
    this.setCurrentRoute({ page: "clients" });
    this.setCurrentRouteChild({ child: "Client Docs" });
  },
  methods: {
    ...mapActions("headertopbar", {
      setCurrentRoute: "setRoute",
      setCurrentRouteChild: "setRouteChild",
    }),
    normalizeOptions(node) {
      return {
        id: node.id,
        label: node.label,
      };
    },
    onClientSearchChange(query) {
      var self = this;
      if (this.clientSearchTimer) clearTimeout(this.clientSearchTimer);
      this.clientSearchTimer = setTimeout(function () {
        self.clientSearchQuery = query || "";
      }, 200);
    },
    async getClients() {
      this.loadingClients = true;
      try {
        var result = await clientsService.getAll();
        var list = Array.isArray(result)
          ? result
          : (result && result.data ? result.data : []);

        list = list.filter(function (client) {
          var sid = parseInt(client.client_status_id, 10);
          return CLIENT_STATUS_IDS_ALLOWED.indexOf(sid) !== -1;
        });

        this.clients = (Array.isArray(list) ? list : []).map(function (client) {
          var label = client.name || "";
          return {
            id: client.id,
            label: label,
            _search: String(label).toLowerCase(),
          };
        });

        if (
          this.filterSearch.client_id != null &&
          !this.clients.some((c) => c.id === this.filterSearch.client_id)
        ) {
          this.filterSearch.client_id = null;
        }
      } finally {
        this.loadingClients = false;
      }
    },
    buildFilters(getTotal) {
      const filters = {
        currentPage: this.pagination.currentPage,
        cantPerPage: this.pagination.cantPerPage,
        getTotal,
      };
      if (this.currentUser.role_id == 1 && this.filterSearch.client_id != null) {
        filters.client_id = this.filterSearch.client_id;
      }
      return filters;
    },
    getDocumentsTotal() {
      this.loadingTotal = true;
      clientsService
        .getClientDocs(this.buildFilters(1))
        .then((result) => {
          const data = result && result.total != null ? result : { total: 0 };
          this.total = Number(data.total) || 0;
        })
        .catch(() => {
          this.total = 0;
        })
        .finally(() => {
          this.loadingTotal = false;
        });
    },
    getDocumentsList() {
      this.loading = true;
      clientsService
        .getClientDocs(this.buildFilters(0))
        .then((result) => {
          const data = result && result.list != null ? result : { list: [] };
          this.documents = Array.isArray(data.list) ? data.list : [];
        })
        .catch(() => {
          this.documents = [];
        })
        .finally(() => {
          this.loading = false;
        });
    },
    loadDocuments(fetchTotal) {
      if (fetchTotal) {
        this.pagination.currentPage = 1;
        this.getDocumentsTotal();
      }
      this.getDocumentsList();
    },
    changePage() {
      this.getDocumentsList();
    },
    downloadKey(row) {
      return `${row.doc_type}-${row.entity_id}`;
    },
    downloadDocument(row) {
      const key = this.downloadKey(row);
      const downloadPromise =
        row.doc_type === "Contract"
          ? clientsService.getContractClient(row.client_id)
          : billingsService.downloadMandatSepa(row.entity_id);
      const defaultName =
        row.doc_type === "Contract"
          ? `contract-${row.client_id}.pdf`
          : `Mandat_SEPA_Oliverlist_${row.entity_id}.pdf`;
      this.downloadFile(key, downloadPromise, defaultName);
    },
    downloadFile(key, downloadPromise, defaultName) {
      this.downloadingKey = key;

      downloadPromise
        .then(({ blob, filename }) => {
          const downloadName = filename
            ? filename.endsWith(".pdf")
              ? filename
              : `${filename}.pdf`
            : defaultName;
          const url = window.URL.createObjectURL(
            new Blob([blob], { type: "application/octet-stream" }),
          );
          const link = document.createElement("a");
          link.href = url;
          link.download = downloadName;
          link.style.display = "none";
          document.body.appendChild(link);
          link.click();
          link.remove();
          setTimeout(() => window.URL.revokeObjectURL(url), 200);
        })
        .catch((err) => {
          console.error(err);
          this.$swal({
            type: "error",
            title: "Error",
            text: "Unable to download document",
            showConfirmButton: false,
            timer: 2500,
          });
        })
        .finally(() => {
          this.downloadingKey = null;
        });
    },
  },
};
</script>

<style scoped>
.client-docs-filter-col {
  min-width: 0;
}

.client-docs-client {
  margin-left: 0;
  padding: 0.5rem 1rem 0.5rem 1rem;
  max-width: 100%;
}
</style>
